module.exports = __webpack_public_path__ + "img/drh5_title_en.1961f5cb.png";